<div *ngIf="clicked !== numbers.THREE" class="modal-header-label bg-white d-block py-2 px-0 mb-1 rounded-0">
  <div class="position-relative m-1 form-input">

    <img class="position-absolute speciality-icon-searching" src="assets/themes/icons/search-icon.svg" alt="search-icon">

    <input autocomplete="off" id="conSearch" (keyup)="searchInTheList($event.target.value)"
      class="speciality-input-search  height-30 input-field pl-4" [placeholder]="filterPlaceholder" />

    <img *ngIf="keyword.length > numbers.ZERO" width="14px"  class="position-absolute cursor-pointer cross-icon" (click)="resetSearchBox()" src="assets/themes/icons/cancel.svg" alt="cross-icon">
  </div>
  <small class="text-danger">
    {{maxLimitErrorMsg}}
  </small>
</div>
<div class="modal-body p-0 main-body-height" *ngIf="!showExistingUsersFlag">
  <div class="position-relative h-100">
    <div class="row m-0 h-100">
      <div id="containerDiv" class="col-md-12 pr-0 pl-0 multi-select-max-height" (scrolled)="onScroll()">

        <div class="text-center" *ngIf="suggestionList.length === numbers.ZERO && apiInProcess===false && clicked === numbers.ZERO">
            <img src="assets/themes/icons/no-search-result.svg" alt="no-search-result-icon">
            <p class="heading-4">{{noDataFoundLabel}}</p>

        </div>

          <div id="addMemDiv" class="ps position-relative h-100" *ngIf="clicked === numbers.ZERO" [perfectScrollbar]="config"
            infiniteScroll [infiniteScrollDistance] = "numbers.ONE" [infiniteScrollThrottle]= "numbers.ONE_THOUSAND" (scrolled)="onScroll()"
            [scrollWindow]="false">
            <div class="bg-white pt-2 pr-3">
              <div *ngIf="suggestionList.length === numbers.ZERO && createCommunityService.membersApiInProcess === true"
                class='text-center'>
                <img src="assets/themes/images/img-video-loader.gif" alt="loader" width="40" height="40" id="loadmore_post">
              </div>

              <div class="asstn-list clearfix pt-2 pb-2 border-bottom last-item-border" *ngFor="let suggestion of suggestionList">
                <label class="checkbox-containers clearfix mb-0" [id]="'COMMUNITY-MEMBER-' + suggestion?.id">
                  <div class="cnnction-rqst">
                    <div class="row pr-3">
                      <div class="col-10 d-flex">
                      <div class="user-container pr-3">
                        <div class="position-relative user-40">
                          <app-conn-user-for-tag [conn]="suggestion"></app-conn-user-for-tag>
                        </div>
                      </div>
                      <div class="pl-0 ml-1">
                        <p class="cnnction-rqst-list-name line-height16px color-grey-700">
                          <span class="secondary-paragraph-bold">
                            {{suggestion?.full_name | titlecase}}
                           </span>
                          <span
                            *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === suggestion?.custom_id)">({{mls.languageText.community.key51}})</span>
                          <span class="ml-2">
                            <!-- Spaces added for responsive layout -->
                          </span>
                          <br />
                          <span class="primary-small text-medium-grey" *ngFor="let spec of suggestion.specialities">
                            {{(spec.is_primary==1)? spec.speciality_name:''}}</span><br />
                          <span class="primary-small color-grey-500" *ngIf="suggestion?.is_community_creator">{{mls.languageText.community.key50}}</span>
                          <span class="primary-small"
                            *ngIf="!(suggestion?.is_community_creator) && (suggestion?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                            | titlecase}}</span>
                          <span class="primary-small"
                            *ngIf="!(suggestion?.is_community_creator) && (suggestion?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                            | titlecase}}</span>
                        </p>
                      </div>
                      </div>
                      <div class="col-2 text-right pl-0 pt-1 pr-0 checkbox" *ngIf="!(suggestion?.is_community_creator)">
                        <input type="checkbox" name=""
                          [checked]="suggestion?.is_community_member === numbers.ONE || checkVal(suggestion)"
                          value="{{suggestion.custom_id}}" (click)="add($event, suggestion)" class="checkbox-right">
                          <!--TODO : remove class-->
                        <span class="checkmark-alignment rounded border bg-white mt-2 ml-1"></span>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>


        <ng-container>
          <div *ngIf="clicked === numbers.ONE && communityId !== '' " class="ps position-relative h-100 "
            [perfectScrollbar]="config" infiniteScroll [infiniteScrollDistance]= "numbers.ONE" [infiniteScrollThrottle]="numbers.ONE_THOUSAND"
            [scrollWindow]="false" (scrolled)="onMemberScroll()">
            <div class="modal-body pt-0 pb-2 pl-2 bg-white ">
              <div *ngIf="memberList.length===0 && apiInProcess === true" class='text-center'>
                <img src="assets/themes/images/img-video-loader.gif" alt="loader" width="40" height="40" id="loadmore_post">
              </div>
              <div class="text-center" *ngIf="memberList.length === numbers.ZERO && apiInProcess===false && clicked === numbers.ONE">
                <img src="assets/themes/icons/no-search-result.svg" alt="no-search-result">
                <p class="heading-4">{{noDataFoundLabel}}</p>
              </div>
              <ul class="clearfix">
                <li class="border-bottom no-last-border pt-2 pb-2" *ngFor="let user of memberList">
                  <div class="row">
                    <div class="col-2 pr-0 width-60 mr-l">
                      <div class="position-relative user-40">
                        <app-conn-user-for-tag  [conn]="user"></app-conn-user-for-tag>
                      </div>
                    </div>
                    <div class="col-8 px-0 width-65">
                      <p class="pl-3">
                        <span class="secondary-paragraph-bold">{{user?.full_name | titlecase}}
                          <span
                            *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user?.custom_id)">({{mls.languageText.community.key51}})</span>
                        </span>
                        <br />
                        <span class="secondary-paragraph color-grey-500" *ngFor="let spec of user?.specialities">
                          {{ ( spec?.is_primary)? spec?.speciality_name: ''}}
                        </span>
                        <br />
                        <span  class="primary-small color-grey-500" *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                          | titlecase}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                          | titlecase}}</span>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="clicked === numbers.THREE " class="ps position-relative h-100 " [perfectScrollbar]="config" infiniteScroll
            [infiniteScrollDistance]=numbers.ONE [infiniteScrollThrottle]=numbers.ONE_THOUSAND [scrollWindow]="false">
            <div class="modal-body pt-0 pb-2 pl-2 bg-white">
              <ul class="clearfix">
                <li class="border-bottom no-last-border pt-2 pb-2" *ngFor="let user of selectedList">
                  <div class="row">
                    <div class="col-2 pr-0 width-60 mr-l">
                      <div class="position-relative user-40">
                        <app-conn-user-for-tag [conn]="user"></app-conn-user-for-tag>
                      </div>
                    </div>
                    <div class="col-8 px-0 width-52">
                      <p class="pl-3">
                        <span class="secondary-paragraph-bold"><span>{{user?.full_name | titlecase}}
                          <span
                            *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user?.custom_id)">({{mls.languageText.community.key51}})</span>
                        </span>
                      </span>
                        <br />
                        <span class="secondary-paragraph color-grey-500" *ngFor="let spec of user?.specialities">
                          {{ ( spec?.is_primary)? spec?.speciality_name: ''}}
                        </span>
                        <br />
                        <span  class="primary-small color-grey-500" *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                          | titlecase}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                          | titlecase}}</span>
                      </p>

                    </div>
                  </div>
                </li>
                <li class="border-bottom no-last-border pt-2 pb-2" *ngFor="let user of removeReview">
                  <div class="row">
                    <div class="col-2 pr-0 width-60 mr-l">
                      <div class="position-relative user-40">
                        <app-conn-user-for-tag [conn]="user"></app-conn-user-for-tag>
                      </div>
                    </div>
                    <div class="col-8 px-0 width-52">
                      <p class="pl-3">
                        <span class="secondary-paragraph-bold"><span>{{user?.full_name | titlecase}}
                          <span
                            *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user?.custom_id)">({{mls.languageText.community.key51}})</span>
                        </span>
                      </span>
                        <br />
                        <span class="secondary-paragraph color-grey-500" *ngFor="let spec of user?.specialities">
                          {{ ( spec?.is_primary)? spec?.speciality_name: ''}}
                        </span>
                        <br />
                        <span  class="primary-small color-grey-500" *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                          | titlecase}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                          | titlecase}}</span>
                      </p>

                    </div>
                  </div>
                </li>

              </ul>
            </div>
          </div>

          <div *ngIf="clicked === numbers.TWO " class="ps position-relative h-100 " class="ps position-relative h-100 "
            [perfectScrollbar]="config" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000"
            [scrollWindow]="false" (scrolled)="onMemberScroll()" >
            <div *ngIf="memberList.length === numbers.ZERO && createCommunityService.membersApiInProcess === true"
                class='text-center'>
                <img src="assets/themes/images/img-video-loader.gif" alt="loader" width="40" height="40" id="loadmore_post">
              </div>
            <div class="modal-body pt-0 pb-2 pl-2">
              <div class="text-center" *ngIf="memberList.length === numbers.ZERO && apiInProcess===false && clicked === numbers.TWO">
                <img src="assets/themes/icons/no-search-result.svg" alt="no-search-result">
                <p class="heading-4">{{noDataFoundLabel}}</p>
              </div>
              <ul class="clearfix">
                <li class=" pt-2 pb-2" *ngFor="let user of memberList let idx = index"
                  class = "border-bottom no-last-border py-2">
                  <div  class="row">
                    <div class="col-2 pr-0 width-60 mr-l">
                      <div class="position-relative user-40">
                        <app-conn-user-for-tag [conn]="user"></app-conn-user-for-tag>
                      </div>
                    </div>
                    <div class="col-6 col-md-7 px-0 ">
                      <p class="pl-3">
                        <span class="secondary-paragraph-bold"><span>{{user?.full_name | titlecase}}
                          <span
                            *ngIf="(user?.is_community_creator || user?.community_member_type === memberType?.ADMIN) && (loggedInUserCustomId === user?.custom_id)">({{mls.languageText.community.key51}})</span>
                        </span>
                      </span>
                        <br />
                        <span class="secondary-paragraph color-grey-500" *ngFor="let spec of user?.specialities">
                          {{ ( spec?.is_primary)? spec?.speciality_name: ''}}
                        </span>
                        <br />
                        <span class="primary-small color-grey-500" *ngIf="user?.is_community_creator">{{mls.languageText.community.key50}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.ADMIN)">{{mls.languageText.community.key53
                          | titlecase}}</span>
                        <span class="primary-small"
                          *ngIf="!(user?.is_community_creator) && (user?.community_member_type === memberType?.MEMBER)">{{mls.languageText.community.key54
                          | titlecase}}</span>
                      </p>

                    </div>
                    <div class="col-3 pl-0 pt-1 pr-0" >
                      <label *ngIf="!(user?.is_community_creator) && (loggedInUserCustomId !== user?.custom_id)" class="btn-design outline small position-relative ml-0 my-2 float-right" >
                        <input class="d-none" type="checkbox" name="" [checked]="!checkVal(user)"
                          value="{{user.custom_id}}"
                          (click)="clicked === numbers.ZERO ?add($event, user) :remove($event, user); user.is_community_member ? user.is_community_member = 0 :user.is_community_member=1 ">
                        <span *ngIf="!checkVal(user)">{{mls.languageText.community.key165}}</span>
                        <span *ngIf=" checkVal(user) ">{{mls.languageText.community.key170}}</span></label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showMaxPopUp" class="modal fade" tabindex="-1" role="dialog" [config]="{ show: true, backdrop: 'static' }"
  bsModal #autoShownModal="bs-modal">
  <div class="custom-theme-modal modal-dialog modal-dialog-centered" role="document">
   <div class="modal-content ">
     <div class="row pl-1">
      <p class="col-8 mt-4 ml-4 paragraph-bold">{{maxLimitErrorLabel}}{{selectedLimit}} {{title}}</p>
      <span class="col-3 mt-2"><img src="assets/images/cross.svg" alt="icon" (click)="maxPopUpDisable()" class="cursor-pointer ml-2 float-right" /></span></div>
         <div class="m-3">
           <button type="button" (click)="maxPopUpDisable()" class="btn-design small filled float-right" data-dismiss="modal" >{{mls.languageText.community.key173}}</button>
         </div>

     </div>
   </div>
  </div>
